/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepostedBy.defs.js'
export { main as default } from './getRepostedBy.defs.js'
